 <!-- Start About Area -->
 <div class="bk-about-area section-ptb-100" id="section-about" style="background-color: #2c0b46; padding-top: 140px;">
    <div class="container">
        <div class="row about--creative align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
                <div class="thumb text-left text-lg-left wow move-up">
                    <img src="assets/img/ninos/img-del-curso.png" alt="NEUROAKASHICO® NIÑOS">
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12 mt_md--40 mt_sm--40">
                <div class="content pl--80 pl_md--5 pl_sm--5">
                    <div class="title--creative wow move-up">
                        <h3 class="heading">NEUROAKASHICO® UN AVANCE EN NEUROCIENCIAS</h3>
                        <h2>Participa con <span class="theme-creative">Nosotros.</span></h2>
                    </div>
                    <p class="wow move-up">Nuestros cursos están orientados a conservar y desarrollar en los pequeños, practicantes y facilitadores; el Amor, la Luz,la Pureza, la Ternura y la Felicidad que por Naturaleza vive en nuestro interior para así crear juntos, generaciones que coolaboren positiva y conscientemente por el bienestar del mundo.</p>
                    <a class="about-btn wow move-up" href="#" target="_blank"><span>Descarga la formación completa aquí</span><i class="fa fa-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End About Area -->

